import React, { useEffect } from 'react';
import { SaveNewPasswordForm } from '../common/forms/SaveNewPasswordForm';
import { SubmitButton } from '../common/forms/SubmitButton';
import GoogleSSOButton from '../common/sso-buttons/GoogleSSOButton';
import { useDispatch } from 'react-redux';
import { logIn } from '../../../app/auth/auth.actions';
import { IUserCredentialsSSO } from '../../../app/resource/user/user.types';

export const SetPasswordPage = () => {
  const dispatch = useDispatch();

  const handleAuthentication = async (data: IUserCredentialsSSO) => {
    try {
      dispatch(logIn({ token: data.token }));
    } catch (err) {
      console.error('Auth0 Error:', err);
    }
  };
  return (
    <main className="flex aic jcc login">
      <div className="panel w500">
        <div className="panel-header small-header flex jcsb">
          <h3 className="f-2">Enter password</h3>
        </div>
        <div className="panel-body">
          <SaveNewPasswordForm />
        </div>
        <div className="panel-footer no-border flex jcr">
          <SubmitButton apiKey="saveNewPassword" formName="saveNewPassword-form" text="Confirm" />
        </div>
        <div className="panel-body">
          <hr />
          <GoogleSSOButton onClick={handleAuthentication} />
        </div>
      </div>
    </main>
  );
};
